import { Component, OnInit, Input } from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';
@Component({
  selector: 'app-slides',
  templateUrl: './slides.component.html',
  styleUrls: ['./slides.component.scss']
})
export class SlidesComponent extends GridBaseCase {
  @Input() SlideConfig: Array<any>;
  slideOpts:any;
  constructor() {
    super();
  }

  ngOnInit() {
    if (this.template.content) {
     this.slideOpts = {
        "autoplay": this.template.content.autoplay && this.template.content.autoplay != "null" ? {
          delay: this.template.content.autoplay
        } : this.template.content.autoplay,
        // "autoplay":item.content.autoplay,
        "speed": this.template.content.speed,
        "spaceBetween": this.template.content.spaceBetween,
        "slidesPerView": this.template.content.slidesPerView,
        "parallax": this.template.content.parallax,
        "paginationType": this.template.content.paginationType,
        "loop": this.template.content.loop,
        "initialSlide": this.template.content.initialSlide,
        "height": this.template.content.height,
        "pager": this.template.content.pager,
        "centeredSlides": this.template.content.centeredSlides,
        "dir": this.template.content.dir,
        "effect": this.template.content.effect,
        "direction": this.template.content.direction,

      }
    }

  }
  // slideOpts = {
  //   effect: 'fade',
  //   speed: 1500,
  //   loop: true,
  //   autoplay: {
  //     delay: 3000
  //   }
  // };




}
